/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */

/*
 * @param {String} instanceOrProduct
 * @param {Object} requests From http request
 * @param {String} searchKey Optional: only for instances
 * @param {Array} instanceNameList Optional: array containing objects that have instance keys
 * and localized names for search purposes
 */
function getInstanceOptions(instanceOrProduct, requests, searchKey, instanceNameList = []) {
  if (!instanceOrProduct) return [];
  let _instanceOptions;
  if (requests.subscriber.isCompleted &&
    requests.instanceList.isCompleted && requests.products.isCompleted) {
    const _subscriptions = requests.subscriber.value.Subscriptions;
    const products = requests.products.value;
    const instanceList = requests.instanceList.value.filter(instance => instance.isActive);
    if (instanceOrProduct === 'product') {
       _instanceOptions = products.map((obj) => {
        return {
          disabled: Boolean(_subscriptions
            .find((is) => is.productKey === obj.key)),
          id: obj.key,
          text: obj.key,
          value: obj.key,
        };
      });
      return _instanceOptions;
    }

    if (searchKey === '') {
       _instanceOptions = instanceList.map(instancesToOption).sort(alphanum);
    } else {
      _instanceOptions = instanceList.filter((instance) => {
        const instanceName = instanceNameList.find(i => i.key === instance.key);
        return instance.key.toUpperCase().includes(searchKey.toUpperCase().trim()) || instanceName?.localizedName.toUpperCase().includes(searchKey.toUpperCase().trim());
      }).map(instancesToOption).sort(alphanum);
    }
    _instanceOptions.forEach((option) => {
      option.disabled = Boolean(_subscriptions
        .find((is) => is.instanceKey === option.value));
    });
    return _instanceOptions;
  } else return [];
}

const instancesToOption = (instance) => ({
  id: instance.key,
  value: instance.key,
  text: instance.key
});

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

/**
 * @param {Array} arr Array of objects with either key or instanceKey
 * @returns {Array} Array of unique objects
 */
function getInstanceKeys(arr) {
  const _arr = arr.map((inst) => {
    const _value = inst.key || inst.instanceKey;

    if (_value) {
      return {
        disabled: false,
        id: _value,
        text: _value,
        value: _value,
      }
    }
  });

  return removeDuplicates(_arr, 'id');
}

/**
 * @param {Array} json1: includes [{ id: ...}]
 * @param {Array} json2: includes [{ id: ...}]
 * @returns {Array} Includes [{ id: ...}]
 */
function mergeArraysByKey(json1, json2) {
  const _keys = json1.map((_inst) => _inst.id);
  let _addToArr = [];

  json2.forEach((_inst) => {
    // if not found: add
    if (_keys.indexOf(_inst.id) === -1 && _inst.id) {
      _addToArr.push(_inst);
    }
  });

  // returns a new array.
  return json1.concat(_addToArr);
}

function alphanum(a, b) {
  // numeric regex
  const numberOrNotRegex = /\d+|\D+/g;

  const c = a.text;
  const d = b.text;

  // chunk by digit or not digit
  const aChunks = c.match(numberOrNotRegex);
  const bChunks = d.match(numberOrNotRegex);

  // compare each chunk
  for (let x = 0; aChunks[x] && bChunks[x]; x++) {

    // skip if the same

    if (aChunks[x] === bChunks[x]) continue;

    // cast chunks to numbers
    const aNumber = Number(aChunks[x]);
    const bNumber = Number(bChunks[x]);

    // if values were unchanged during casting, then values are numbers
    // test using weak compare

    if (aNumber == aChunks[x] && bNumber == bChunks[x]) {
      return aNumber - bNumber;
    }

    // else use simple compare

    return (aChunks[x] > bChunks[x]) ? 1 : -1;
  }

  // if end of chunks reached compare by number of chunks
  return aChunks.length - bChunks.lenght;
}

const filterInstances = (instanceFilter) => (instance) => {
  const normalizedInstanceFilter = instanceFilter.toUpperCase();
  return instance.key.toUpperCase().includes(normalizedInstanceFilter);
};

module.exports = {
  getInstanceOptions,
  filterInstances,
  instancesToOption,
  mergeArraysByKey,
  getInstanceKeys,
  alphanum,
}
